import axios from '@/libs/api.request'
// 获取批量信息
export const getList = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/index',
    method: 'get',
    data
  })
}
// 获取单个信息
export const getDetails = (params) => {
  return axios.request({
    url: `/finance/zaf/hq/bill/detail/${params.id}`,
    method: 'GET',
	params
  })
}
// 删除单个信息
export const del = (id) => {
  return axios.request({
    url: `/finance/dblChargingType/${id}`,
    method: 'DELETE'
  })
}
// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/finance/zaf/hq/bill/update/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  return axios.request({
    url: '/finance/dblChargingType',
    method: 'POST',
    data
  })
}

export const recalculate = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/recalculate',
    method: 'POST',
    data
  })
}

export const sync = () => {
  return axios.request({
    url: `/finance/zaf/hq/detail/sync`,
    method: 'GET'
  })
}

export const createBill = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/detail/createBill',
    method: 'POST',
    data
  })
}

export const append = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/append/'+data.id,
    method: 'POST',
    data
  })
}

export const confirm = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/confirm',
    method: 'POST',
    data
  })
}

export const cancelConfirm = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/cancelConfirm',
    method: 'POST',
    data
  })
}
export const deleteBill = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/deleteBill',
    method: 'DELETE',
    data
  })
}

export const saveRates = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/saveRates',
    method: 'POST',
    data
  })
}

export const getRates = (params) => {
  return axios.request({
    url: `/finance/zaf/hq/bill/getRates`,
    method: 'GET',
	params
  })
}
export const getConfig = (params) => {
  return axios.request({
    url: `/finance/zaf/hq/bill/config`,
    method: 'GET',
	params
  })
}

export const getWriteOffData = (params) => {
  return axios.request({
    url: `/finance/zaf/hq/bill/getWriteOffData`,
    method: 'GET',
	params
  })
}

export const writeOff = (data) => {
  return axios.request({
    url: '/finance/zaf/hq/bill/writeOff',
    method: 'POST',
    data
  })
}

export const setException = data => {
  return axios.request({
    url: `/finance/zaf/hq/bill/setException/${data.id}`,
    method: "POST",
    data
  });
};
export const removeDetail = data => {
  return axios.request({
    url: `/finance/zaf/hq/bill/removeDetail/${data.id}`,
    method: "POST",
    data
  });
};

Export

export const Export = id => {
  return axios.request({
    url: `/finance/zaf/hq/bill/export/${id}`,
    method: "POST",
  });
};

export const ExportWanted = id => {
  return axios.request({
    url: `/finance/zaf/hq/bill/export/${id}?type=wanted`,
    method: "POST",
  });
};
